import React, { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'

const ErrorModal = ({
  showErrorModal,
  setShowErrorModal,
  additionalText,
  setAdditionalText
  }) => {

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
    if (setAdditionalText)
      setAdditionalText(null);
  }

  return <Modal show={showErrorModal} onHide={handleCloseErrorModal} animation={false} centered>
    <Modal.Header>
      <Modal.Title>{I18n.t('js.common.modal.errorTitle')}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h4>
        <div className="d-block text-center">
          <div className="d-flex justify-content-center align-items-center">
            <i className="fas fa-exclamation-triangle" style={{fontSize:"40px"}} />
            <p className="ml-2 text-space">{I18n.t('js.common.modal.generalError')}</p>
          </div>
          {
            additionalText &&
              <div className="d-flex justify-content-center align-items-center mt-4">
                <p className="ml-2 text-space">
                 { additionalText }
                </p>
              </div>
          }
        </div>
      </h4>
    </Modal.Body>
    <Modal.Footer>
      <button
        type="button"
        className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized text-weight-500"
        onClick={handleCloseErrorModal}
      >
        {I18n.t('js.common.ok').toUpperCase()}
      </button>
    </Modal.Footer>
  </Modal>
};

export default ErrorModal;